export default __webpack_public_path__ + "static/media/bg-lower-left-corner.bab83ab9.svg";